// @flow
import React from 'react';
import { Grid } from 'semantic-ui-react';

import { InfoMessageContainer } from '../../presentational/messages/InfoMessageContainer';
import { formatCurrency0DP } from '../../views/grid-utils/renderers';
import { useIsUserAdmin } from '../../../custom-hooks/useIsUserAdmin';
import { ESTIMATE_CC_METRIC_NAMES } from '../enums';
import {
  getIfGivenRowIsANewlyAddedRowForEstimateCC,
  getMaxQuantityForMetricAndUserTypeForEstimateCC,
} from '../utils';

// Shown to non-admins on a newly added Streamhouse Accelerator (DSP Starter Pack) row to
// explain that % Discount is locked and that the Commitment Amount is capped for them.
export const DSPSPFixedDiscountInfoMessageForEstimateCC = ({ dimensionRow, metricName }) => {
  const isUserAdmin = useIsUserAdmin();
  const isDSPSPRow = metricName === ESTIMATE_CC_METRIC_NAMES.DSP_STARTER_PACK;
  const isNewRow = getIfGivenRowIsANewlyAddedRowForEstimateCC(dimensionRow);

  if (!isDSPSPRow || isUserAdmin || !isNewRow) {
    return null;
  }

  const maxCommitmentAmountForNonAdmins = getMaxQuantityForMetricAndUserTypeForEstimateCC(
    ESTIMATE_CC_METRIC_NAMES.DSP_STARTER_PACK,
    false
  );

  return (
    <Grid.Row style={{ paddingTop: '1rem' }}>
      <Grid.Column width={16}>
        <InfoMessageContainer
          compact={true}
          message={`The % discount is fixed at the standard Streamhouse Accelerator rate and can't be edited. The commitment amount can be set at up to ${formatCurrency0DP.format(
            maxCommitmentAmountForNonAdmins
          )}; contact an administrator to request a higher amount.`}
        />
      </Grid.Column>
    </Grid.Row>
  );
};
